const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharisLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "700px",
    height: "200px",
    viewBox: "0 0 800 200",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "none",
    d: "M -0.5,-0.5 C 263.5,-0.5 527.5,-0.5 791.5,-0.5C 791.5,73.1667 791.5,146.833 791.5,220.5C 527.5,220.5 263.5,220.5 -0.5,220.5C -0.5,146.833 -0.5,73.1667 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909090",
    d: "M 735.5,153.5 C 724.482,153.619 713.482,153.286 702.5,152.5C 691.683,150.839 681.849,146.839 673,140.5C 674.263,132.793 677.097,125.626 681.5,119C 687.756,122.453 694.423,125.453 701.5,128C 715.223,132.488 728.89,132.488 742.5,128C 748.29,123.862 749.957,118.362 747.5,111.5C 745.246,109.081 742.579,107.248 739.5,106C 727.471,102.391 715.471,98.891 703.5,95.5C 701.485,94.0762 699.152,93.4095 696.5,93.5C 677.12,84.9191 670.287,70.2525 676,49.5C 683.282,34.2464 695.449,25.4131 712.5,23C 731.163,20.5932 749.163,22.9265 766.5,30C 768.09,31.0458 769.59,32.2125 771,33.5C 769.82,40.7164 767.32,47.5497 763.5,54C 762.167,54.6667 760.833,54.6667 759.5,54C 745.028,46.2733 729.694,43.9399 713.5,47C 702.711,52.0531 700.711,59.3864 707.5,69C 710.186,70.3678 712.853,71.7011 715.5,73C 728.99,76.0516 742.324,79.7183 755.5,84C 773.227,90.9545 780.393,103.788 777,122.5C 772.462,138.037 762.295,147.87 746.5,152C 742.855,152.719 739.188,153.219 735.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909090",
    d: "M 93.5,153.5 C 84.1483,153.566 74.815,153.232 65.5,152.5C 38.8999,146.4 22.3999,130.067 16,103.5C 10.097,69.4752 22.2637,44.3085 52.5,28C 74.8043,20.1063 96.8043,20.773 118.5,30C 125.221,33.5507 130.887,38.384 135.5,44.5C 130.131,50.8705 124.131,56.5371 117.5,61.5C 104.47,47.8855 88.8037,43.7189 70.5,49C 48.6636,58.8371 40.1636,75.6704 45,99.5C 52.6016,122.392 68.4349,132.225 92.5,129C 102.276,127.113 110.61,122.613 117.5,115.5C 124.693,120.521 130.526,126.521 135,133.5C 123.575,145.129 109.741,151.796 93.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909090",
    d: "M 156.5,24.5 C 166.5,24.5 176.5,24.5 186.5,24.5C 186.5,41.5 186.5,58.5 186.5,75.5C 205.833,75.5 225.167,75.5 244.5,75.5C 244.5,58.5 244.5,41.5 244.5,24.5C 254.5,24.5 264.5,24.5 274.5,24.5C 274.667,66.168 274.5,107.835 274,149.5C 273.626,150.416 273.126,151.25 272.5,152C 263.506,152.5 254.506,152.666 245.5,152.5C 245.5,134.833 245.5,117.167 245.5,99.5C 225.833,99.5 206.167,99.5 186.5,99.5C 186.833,116.846 186.5,134.179 185.5,151.5C 175.97,152.823 166.47,152.823 157,151.5C 156.5,109.168 156.333,66.8346 156.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909090",
    d: "M 621.5,24.5 C 631.5,24.5 641.5,24.5 651.5,24.5C 651.667,66.5013 651.5,108.501 651,150.5C 650.5,151 650,151.5 649.5,152C 640.255,152.817 631.089,152.65 622,151.5C 621.5,109.168 621.333,66.8346 621.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8f8f",
    d: "M 597.5,149.5 C 588.225,151.473 578.558,152.14 568.5,151.5C 560.167,140.167 551.833,128.833 543.5,117.5C 534.348,116.506 525.015,116.173 515.5,116.5C 515.5,128.167 515.5,139.833 515.5,151.5C 506,152.821 496.5,152.821 487,151.5C 486.5,109.168 486.333,66.8346 486.5,24.5C 510.872,24.0602 535.205,24.5602 559.5,26C 587.692,32.8971 600.192,50.7305 597,79.5C 593.532,94.139 585.032,104.806 571.5,111.5C 580.177,124.196 588.843,136.862 597.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8f8f8f",
    d: "M 379.5,32.5 C 381.903,32.393 383.736,33.393 385,35.5C 410.667,65.8333 436.333,96.1667 462,126.5C 465.266,131.738 466.266,137.405 465,143.5C 461.754,146.876 457.921,148.709 453.5,149C 438.014,139.176 422.181,130.009 406,121.5C 397.636,125.184 389.303,128.85 381,132.5C 372.853,129.676 365.02,126.176 357.5,122C 355.833,121.333 354.167,121.333 352.5,122C 338.163,131.171 323.496,139.837 308.5,148C 298.465,148.285 294.631,143.451 297,133.5C 297.36,131.392 298.027,129.392 299,127.5C 326.044,95.9607 352.877,64.294 379.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 516.5,48.5 C 526.839,48.3335 537.172,48.5002 547.5,49C 560.298,50.6263 566.964,57.793 567.5,70.5C 567.305,84.3612 560.305,91.6946 546.5,92.5C 536.5,92.5 526.5,92.5 516.5,92.5C 516.5,77.8333 516.5,63.1667 516.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6d6d6",
    d: "M 516.5,48.5 C 516.5,63.1667 516.5,77.8333 516.5,92.5C 526.5,92.5 536.5,92.5 546.5,92.5C 536.347,93.4942 526.014,93.8276 515.5,93.5C 515.171,78.324 515.504,63.324 516.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b1b1",
    d: "M 696.5,93.5 C 699.152,93.4095 701.485,94.0762 703.5,95.5C 700.848,95.5905 698.515,94.9238 696.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4d4d4",
    d: "M 543.5,117.5 C 534.5,117.5 525.5,117.5 516.5,117.5C 516.828,129.012 516.495,140.346 515.5,151.5C 515.5,139.833 515.5,128.167 515.5,116.5C 525.015,116.173 534.348,116.506 543.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9f9f9f",
    d: "M 597.5,149.5 C 598.404,150.209 598.737,151.209 598.5,152.5C 588.319,152.827 578.319,152.494 568.5,151.5C 578.558,152.14 588.225,151.473 597.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b6b6",
    d: "M 65.5,152.5 C 74.815,153.232 84.1483,153.566 93.5,153.5C 90.0159,154.165 86.3492,154.499 82.5,154.5C 76.5915,154.651 70.9248,153.984 65.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2b2b2",
    d: "M 702.5,152.5 C 713.482,153.286 724.482,153.619 735.5,153.5C 731.347,154.166 727.013,154.499 722.5,154.5C 715.602,154.654 708.936,153.987 702.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b8b8b8",
    d: "M 629.5,173.5 C 637.984,172.507 646.651,172.174 655.5,172.5C 655.768,174.099 655.434,175.432 654.5,176.5C 654.5,175.5 654.5,174.5 654.5,173.5C 646.167,173.5 637.833,173.5 629.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#959595",
    d: "M 383.5,176.5 C 377.833,176.5 372.167,176.5 366.5,176.5C 366.194,179.385 366.527,182.052 367.5,184.5C 372.017,185.166 376.683,185.833 381.5,186.5C 376.683,187.167 372.017,187.834 367.5,188.5C 366.527,190.948 366.194,193.615 366.5,196.5C 372.167,196.5 377.833,196.5 383.5,196.5C 383.5,197.5 383.5,198.5 383.5,199.5C 376.167,199.5 368.833,199.5 361.5,199.5C 361.5,190.5 361.5,181.5 361.5,172.5C 368.833,172.5 376.167,172.5 383.5,172.5C 383.5,173.833 383.5,175.167 383.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3b3b3",
    d: "M 664.5,173.5 C 663.167,173.5 661.833,173.5 660.5,173.5C 660.5,182.167 660.5,190.833 660.5,199.5C 659.507,190.682 659.173,181.682 659.5,172.5C 661.415,172.216 663.081,172.549 664.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969696",
    d: "M 214.5,173.5 C 217.564,173.144 220.231,173.977 222.5,176C 226.648,180.982 230.981,185.816 235.5,190.5C 236.495,184.872 236.829,179.206 236.5,173.5C 238.167,173.5 239.833,173.5 241.5,173.5C 241.5,182.167 241.5,190.833 241.5,199.5C 239.801,199.66 238.134,199.494 236.5,199C 231.7,193.198 226.533,187.698 221,182.5C 220.501,188.157 220.334,193.824 220.5,199.5C 218.5,199.5 216.5,199.5 214.5,199.5C 214.5,190.833 214.5,182.167 214.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c9c9c",
    d: "M 423.5,172.5 C 425.144,172.286 426.644,172.62 428,173.5C 428.667,182.167 428.667,190.833 428,199.5C 426.333,200.833 424.667,200.833 423,199.5C 422.196,190.422 422.363,181.422 423.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 475.5,173.5 C 475.5,181.167 475.5,188.833 475.5,196.5C 478.5,196.5 481.5,196.5 484.5,196.5C 486.833,196.5 489.167,196.5 491.5,196.5C 491.67,197.822 491.337,198.989 490.5,200C 483.842,200.5 477.175,200.666 470.5,200.5C 470.5,191.5 470.5,182.5 470.5,173.5C 472.167,173.5 473.833,173.5 475.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939393",
    d: "M 578.5,173.5 C 578.5,181.167 578.5,188.833 578.5,196.5C 583.833,196.5 589.167,196.5 594.5,196.5C 594.5,197.833 594.5,199.167 594.5,200.5C 587.5,200.5 580.5,200.5 573.5,200.5C 573.5,191.5 573.5,182.5 573.5,173.5C 575.167,173.5 576.833,173.5 578.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999999",
    d: "M 270.5,185.5 C 266.087,187.138 261.421,188.138 256.5,188.5C 256.5,191.167 256.5,193.833 256.5,196.5C 262.167,196.5 267.833,196.5 273.5,196.5C 273.67,197.822 273.337,198.989 272.5,200C 265.174,200.5 257.841,200.666 250.5,200.5C 250.5,191.167 250.5,181.833 250.5,172.5C 257.833,172.5 265.167,172.5 272.5,172.5C 272.5,173.833 272.5,175.167 272.5,176.5C 267.167,176.5 261.833,176.5 256.5,176.5C 256.5,179.167 256.5,181.833 256.5,184.5C 261.363,184.181 266.03,184.514 270.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dedede",
    d: "M 475.5,173.5 C 476.492,180.648 476.825,187.981 476.5,195.5C 479.385,195.194 482.052,195.527 484.5,196.5C 481.5,196.5 478.5,196.5 475.5,196.5C 475.5,188.833 475.5,181.167 475.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5d5d5",
    d: "M 578.5,173.5 C 579.492,180.648 579.825,187.981 579.5,195.5C 584.695,195.179 589.695,195.513 594.5,196.5C 589.167,196.5 583.833,196.5 578.5,196.5C 578.5,188.833 578.5,181.167 578.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969696",
    d: "M 599.5,173.5 C 600.833,173.5 602.167,173.5 603.5,173.5C 603.666,179.509 603.499,185.509 603,191.5C 602.014,192.171 600.847,192.171 599.5,191.5C 598.167,185.5 598.167,179.5 599.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1e1e1",
    d: "M 383.5,176.5 C 378.36,177.488 373.026,177.821 367.5,177.5C 367.5,179.833 367.5,182.167 367.5,184.5C 366.527,182.052 366.194,179.385 366.5,176.5C 372.167,176.5 377.833,176.5 383.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939393",
    d: "M 664.5,173.5 C 665.657,181.99 665.824,190.657 665,199.5C 663.384,200.801 661.884,200.801 660.5,199.5C 660.5,190.833 660.5,182.167 660.5,173.5C 661.833,173.5 663.167,173.5 664.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b1b1",
    d: "M 38.5,173.5 C 37.1667,173.5 35.8333,173.5 34.5,173.5C 34.5,179.833 34.5,186.167 34.5,192.5C 33.5093,186.021 33.176,179.354 33.5,172.5C 35.4147,172.216 37.0813,172.549 38.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919191",
    d: "M 629.5,173.5 C 637.833,173.5 646.167,173.5 654.5,173.5C 654.5,174.5 654.5,175.5 654.5,176.5C 651.223,176.216 648.057,176.549 645,177.5C 644.5,184.826 644.334,192.159 644.5,199.5C 642.302,199.88 640.635,199.213 639.5,197.5C 639.5,190.5 639.5,183.5 639.5,176.5C 636.167,176.5 632.833,176.5 629.5,176.5C 629.5,175.5 629.5,174.5 629.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 683.5,172.5 C 691.215,171.571 697.715,173.904 703,179.5C 706.995,189.675 703.829,196.509 693.5,200C 683.887,202.106 676.721,198.939 672,190.5C 670.552,181.053 674.385,175.053 683.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 683.5,176.5 C 695.065,175.229 699.898,180.229 698,191.5C 691.91,197.708 685.577,198.041 679,192.5C 675.975,185.742 677.475,180.409 683.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M 544.5,172.5 C 552.53,171.544 559.363,173.877 565,179.5C 568.611,187.994 566.444,194.494 558.5,199C 548.863,202.645 541.03,200.479 535,192.5C 532.108,182.907 535.274,176.24 544.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 545.5,176.5 C 557.043,175.208 561.876,180.208 560,191.5C 552.86,198.426 546.193,198.093 540,190.5C 538.268,184.314 540.101,179.647 545.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999999",
    d: "M 512.5,172.5 C 517.866,172.042 523.033,172.709 528,174.5C 528.617,175.449 528.451,176.282 527.5,177C 523.199,176.637 518.866,176.637 514.5,177C 512.302,178.67 511.968,180.67 513.5,183C 518.323,183.83 522.989,185.164 527.5,187C 531.802,191.797 531.136,195.797 525.5,199C 519.43,201.099 513.43,200.933 507.5,198.5C 506.571,197.311 506.238,195.978 506.5,194.5C 511.704,196.254 517.037,196.754 522.5,196C 524.192,194.599 524.859,192.766 524.5,190.5C 520.964,189.242 517.297,188.409 513.5,188C 504.535,183.382 504.202,178.215 512.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2d2d2",
    d: "M 629.5,176.5 C 632.833,176.5 636.167,176.5 639.5,176.5C 639.5,183.5 639.5,190.5 639.5,197.5C 638.509,191.021 638.176,184.354 638.5,177.5C 635.287,177.81 632.287,177.477 629.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 731.5,190.5 C 731.56,191.043 731.893,191.376 732.5,191.5C 733.496,185.537 733.829,179.537 733.5,173.5C 734.884,172.199 736.384,172.199 738,173.5C 738.667,182.167 738.667,190.833 738,199.5C 736.612,200.554 735.112,200.72 733.5,200C 728.366,193.865 722.866,188.031 717,182.5C 716.501,188.157 716.334,193.824 716.5,199.5C 714.5,199.5 712.5,199.5 710.5,199.5C 710.183,190.915 710.517,182.415 711.5,174C 714.522,173.836 717.189,174.836 719.5,177C 723.337,181.669 727.337,186.169 731.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b6b6",
    d: "M 733.5,173.5 C 733.829,179.537 733.496,185.537 732.5,191.5C 731.893,191.376 731.56,191.043 731.5,190.5C 732.167,184.833 732.833,179.167 733.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2b2b2",
    d: "M 201.5,173.5 C 202.919,172.549 204.585,172.216 206.5,172.5C 206.5,181.833 206.5,191.167 206.5,200.5C 204.901,200.768 203.568,200.434 202.5,199.5C 203.5,199.5 204.5,199.5 205.5,199.5C 205.5,190.833 205.5,182.167 205.5,173.5C 204.167,173.5 202.833,173.5 201.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeaeae",
    d: "M 270.5,185.5 C 271.404,186.209 271.737,187.209 271.5,188.5C 266.5,188.5 261.5,188.5 256.5,188.5C 261.421,188.138 266.087,187.138 270.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeaeae",
    d: "M 367.5,184.5 C 372.5,184.5 377.5,184.5 382.5,184.5C 382.5,185.833 382.5,187.167 382.5,188.5C 377.5,188.5 372.5,188.5 367.5,188.5C 372.017,187.834 376.683,187.167 381.5,186.5C 376.683,185.833 372.017,185.166 367.5,184.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1d1d1",
    d: "M 625.5,191.5 C 625.5,185.5 625.5,179.5 625.5,173.5C 623.833,173.5 622.167,173.5 620.5,173.5C 620.823,180.022 620.49,186.355 619.5,192.5C 619.5,185.833 619.5,179.167 619.5,172.5C 621.833,172.5 624.167,172.5 626.5,172.5C 626.823,179.022 626.49,185.355 625.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 751.5,172.5 C 756.527,172.503 761.527,172.836 766.5,173.5C 766.884,175.665 766.217,177.332 764.5,178.5C 760.312,176.331 755.978,175.998 751.5,177.5C 750.24,179.353 750.24,181.186 751.5,183C 756.296,183.91 760.963,185.243 765.5,187C 769.5,190.667 769.5,194.333 765.5,198C 760.398,200.343 755.064,201.01 749.5,200C 747.349,199.735 745.682,198.735 744.5,197C 744.613,195.72 745.28,194.887 746.5,194.5C 751.006,196.384 755.673,196.884 760.5,196C 763.033,194.084 763.033,192.084 760.5,190C 757.576,189.012 754.576,188.346 751.5,188C 742.195,182.695 742.195,177.528 751.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 110.5,183.5 C 110.44,182.957 110.107,182.624 109.5,182.5C 108.505,188.128 108.171,193.794 108.5,199.5C 107.167,199.5 105.833,199.5 104.5,199.5C 104.5,190.833 104.5,182.167 104.5,173.5C 107.325,173.081 109.491,174.081 111,176.5C 113.919,181.34 117.086,186.006 120.5,190.5C 121.814,189.687 122.981,188.687 124,187.5C 125.934,183.241 128.268,179.241 131,175.5C 132.789,173.771 134.956,173.104 137.5,173.5C 137.5,182.5 137.5,191.5 137.5,200.5C 135.833,200.5 134.167,200.5 132.5,200.5C 132.829,194.794 132.495,189.128 131.5,183.5C 128.146,188.014 124.646,192.347 121,196.5C 116.603,192.932 113.103,188.598 110.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bebebe",
    d: "M 110.5,183.5 C 109.833,188.833 109.167,194.167 108.5,199.5C 108.171,193.794 108.505,188.128 109.5,182.5C 110.107,182.624 110.44,182.957 110.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 72.5,173.5 C 78.8017,178.969 84.6351,184.969 90,191.5C 90.4995,185.509 90.6662,179.509 90.5,173.5C 92.1667,173.5 93.8333,173.5 95.5,173.5C 95.5,182.5 95.5,191.5 95.5,200.5C 94.1266,200.657 92.7932,200.49 91.5,200C 86.3381,193.838 80.8381,188.005 75,182.5C 74.6667,187.833 74.3333,193.167 74,198.5C 72.6439,199.38 71.1439,199.714 69.5,199.5C 69.5,190.833 69.5,182.167 69.5,173.5C 70.5,173.5 71.5,173.5 72.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 446.5,173.5 C 449.652,173.047 452.152,174.047 454,176.5C 458.139,184.442 461.972,192.442 465.5,200.5C 460.877,201.219 458.21,199.219 457.5,194.5C 452.198,193.337 446.864,193.171 441.5,194C 440.373,195.753 439.373,197.587 438.5,199.5C 436.955,200.452 435.288,200.785 433.5,200.5C 437.061,191.048 441.394,182.048 446.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cacaca",
    d: "M 444.5,187.5 C 447.337,189.402 450.671,190.069 454.5,189.5C 451.038,190.482 447.371,190.815 443.5,190.5C 443.263,189.209 443.596,188.209 444.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4f4",
    d: "M 454.5,189.5 C 450.671,190.069 447.337,189.402 444.5,187.5C 445.611,184.144 447.277,181.144 449.5,178.5C 451.99,181.812 453.657,185.478 454.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#959595",
    d: "M 155.5,173.5 C 157.792,173.244 159.959,173.577 162,174.5C 166.182,182.864 170.349,191.198 174.5,199.5C 172.926,200.631 171.259,200.798 169.5,200C 168.373,198.247 167.373,196.413 166.5,194.5C 161.198,193.337 155.864,193.171 150.5,194C 149.455,198.215 146.788,200.382 142.5,200.5C 146.012,191.141 150.346,182.141 155.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfcfcf",
    d: "M 153.5,188.5 C 156.625,189.479 159.958,189.813 163.5,189.5C 159.981,190.808 156.315,190.808 152.5,189.5C 152.624,188.893 152.957,188.56 153.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 163.5,189.5 C 159.958,189.813 156.625,189.479 153.5,188.5C 154.628,184.91 156.295,181.577 158.5,178.5C 160.979,181.792 162.646,185.459 163.5,189.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 337.5,172.5 C 340.652,172.047 343.152,173.047 345,175.5C 349.398,183.627 353.232,191.96 356.5,200.5C 354.801,200.66 353.134,200.494 351.5,200C 350.269,194.058 346.602,191.892 340.5,193.5C 335.334,192.724 331.667,194.557 329.5,199C 328.207,199.49 326.873,199.657 325.5,199.5C 325.687,197.436 326.187,195.436 327,193.5C 331.038,186.757 334.538,179.757 337.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c8c8",
    d: "M 335.5,188.5 C 338.833,189.833 342.167,189.833 345.5,188.5C 346.043,188.56 346.376,188.893 346.5,189.5C 342.5,190.833 338.5,190.833 334.5,189.5C 334.624,188.893 334.957,188.56 335.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 345.5,188.5 C 342.167,189.833 338.833,189.833 335.5,188.5C 338.773,176.534 342.106,176.534 345.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999999",
    d: "M 391.5,172.5 C 399.173,171.736 406.507,172.903 413.5,176C 416.097,178.317 416.93,181.15 416,184.5C 414.86,187.621 413.027,190.121 410.5,192C 412.348,194.354 414.014,196.854 415.5,199.5C 413.833,200.833 412.167,200.833 410.5,199.5C 408.642,197.476 406.975,195.309 405.5,193C 402.518,192.502 399.518,192.335 396.5,192.5C 396.663,194.857 396.497,197.19 396,199.5C 394.333,200.833 392.667,200.833 391,199.5C 390.196,190.422 390.363,181.422 391.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9f9",
    d: "M 396.5,176.5 C 400.605,176.234 404.605,176.734 408.5,178C 411.343,181.619 411.01,184.952 407.5,188C 403.848,188.499 400.182,188.665 396.5,188.5C 396.5,184.5 396.5,180.5 396.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939393",
    d: "M 201.5,173.5 C 202.833,173.5 204.167,173.5 205.5,173.5C 205.5,182.167 205.5,190.833 205.5,199.5C 204.5,199.5 203.5,199.5 202.5,199.5C 196.569,194.236 190.902,188.569 185.5,182.5C 184.505,188.128 184.171,193.794 184.5,199.5C 182.833,199.5 181.167,199.5 179.5,199.5C 179.5,190.833 179.5,182.167 179.5,173.5C 181.199,173.34 182.866,173.506 184.5,174C 189.727,179.638 195.061,185.138 200.5,190.5C 201.495,184.872 201.829,179.206 201.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b6b6",
    d: "M 72.5,173.5 C 71.5,173.5 70.5,173.5 69.5,173.5C 69.5,182.167 69.5,190.833 69.5,199.5C 68.5067,190.682 68.1734,181.682 68.5,172.5C 70.099,172.232 71.4324,172.566 72.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dddddd",
    d: "M 367.5,188.5 C 367.5,190.833 367.5,193.167 367.5,195.5C 373.358,195.178 379.025,195.511 384.5,196.5C 384.167,196.5 383.833,196.5 383.5,196.5C 377.833,196.5 372.167,196.5 366.5,196.5C 366.194,193.615 366.527,190.948 367.5,188.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M 34.5,192.5 C 34.5,186.167 34.5,179.833 34.5,173.5C 35.8333,173.5 37.1667,173.5 38.5,173.5C 39.3279,179.653 39.8279,185.987 40,192.5C 41.3929,195.366 43.7262,196.699 47,196.5C 49.8139,196.592 52.1473,195.592 54,193.5C 54.3333,186.833 54.6667,180.167 55,173.5C 56.6995,172.594 58.5328,172.261 60.5,172.5C 60.6662,178.842 60.4995,185.175 60,191.5C 59.0513,196.781 55.8847,199.614 50.5,200C 45.0066,201.358 40.1733,200.191 36,196.5C 35.2086,195.255 34.7086,193.922 34.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#989898",
    d: "M 280.5,172.5 C 288.813,171.752 296.813,172.918 304.5,176C 311.076,182.981 311.076,189.981 304.5,197C 296.857,200.375 288.857,201.375 280.5,200C 279.179,190.833 279.179,181.667 280.5,172.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 285.5,176.5 C 292.81,175.215 298.976,177.215 304,182.5C 305.607,189.783 302.774,194.283 295.5,196C 292.183,196.498 288.85,196.665 285.5,196.5C 285.5,189.833 285.5,183.167 285.5,176.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#949494",
    d: "M 599.5,173.5 C 600.919,172.549 602.585,172.216 604.5,172.5C 604.334,179.175 604.5,185.842 605,192.5C 608.377,196.749 612.543,197.582 617.5,195C 618.381,194.292 619.047,193.458 619.5,192.5C 620.49,186.355 620.823,180.022 620.5,173.5C 622.167,173.5 623.833,173.5 625.5,173.5C 625.5,179.5 625.5,185.5 625.5,191.5C 623.483,197.686 619.15,200.686 612.5,200.5C 605.452,201.16 601.119,198.16 599.5,191.5C 600.847,192.171 602.014,192.171 603,191.5C 603.499,185.509 603.666,179.509 603.5,173.5C 602.167,173.5 600.833,173.5 599.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3b3b3",
    d: "M 383.5,196.5 C 383.833,196.5 384.167,196.5 384.5,196.5C 384.5,197.833 384.5,199.167 384.5,200.5C 376.648,200.825 368.982,200.492 361.5,199.5C 368.833,199.5 376.167,199.5 383.5,199.5C 383.5,198.5 383.5,197.5 383.5,196.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharisLogo);
export default __webpack_public_path__ + "static/media/CharisLogo.2eaf59e95e637563c8db990009388c81.svg";
export { ForwardRef as ReactComponent };